module.exports = __webpack_public_path__ + "img/gauge-high.1ff5c658.svg";